import { useContext, useEffect, useState } from "react";
import KrFormContext, { KrFormContextLandslideType, KrLandslideFormTypes, NavHeadingsKROEnum, landSlideAttributes } from "../../../../contexts/krFormContext";
import SelectInput from "../../../../components/shared/selectInput/selectInput";
import { styleFormField, styleFormFieldHalf } from "../../../../components/shared/stylization";
import { GetOptions, prepareDataSingleForSelect } from "../../../../helpers/prepareForSelect";
import TextAreaField from "../../../../components/textAreaField/textAreaField";
import { TextAreaFieldProps } from "../../../../components/textAreaField/types/textAreaFieldProps";
import { createConfigValidation } from "../../../../helpers/validation/validation";
import { FormSectionProps } from "./shared/types/formSectionProps";
import { Option } from "../../../../components/shared/selectInput/types/selectInputProps";
import CollectiveSelectField from "../../collectiveEditionView/collectiveField/collectiveSelectField";
import { CollectivePreviewKey } from "../../../../helpers/collective/preview";
import { getAddCommentBtnDetails, getFieldRef, getItemRef } from "../../../../helpers/form";
import { KROFieldDict } from "../../shared/commentsSidebar/fieldDict";
import { PatternType } from "../../../../contexts/types/card";


const Characteristics = (props: FormSectionProps) => {
    var { krForm, setkrForm } = useContext(KrFormContext) as KrFormContextLandslideType;
    var geomorfologicDict = GetOptions("SYTUACJA_GEOMORFOLOGICZNA_SID", krForm.dictionaries, true);
    var geologicDict = GetOptions("UKLAD_GEOLOGICZNY_SID", krForm.dictionaries, true);
    var MaterialDict = GetOptions("RODZAJ_MATERIALU_SID", krForm.dictionaries, true);
    var MovingDict = GetOptions("RODZAJ_RUCHU_SID", krForm.dictionaries, true);

    const isFormNotValid = krForm.config?.isValid !== undefined ? !krForm.config?.isValid : false;

    const [errorTipsText, setErrorTipsText] = useState<{ [key: string]: string | undefined }>({
        sytuacjA_GEOMORFOLOGICZNA_SID: '',
        uklaD_GEOLOGICZNY_SID: '',
        rodzaJ_MATERIALU_SID: '',
        rodzaJ_RUCHU_SID: '',
        charakterystykA_OPIS: ''
    });
    const [reload, setReload] = useState(false);

    // Validation
    useEffect(() => {
        if (krForm.config?.check && !krForm.config.isValid) {
            for (const key of Object.keys(errorTipsText)) {
                setError(key);
            }
            setReload(!reload);
        }    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [krForm.config?.check])

    const setError = (key: string) => {
        const errorMsg = krForm.config?.ValidationError![key];
        if (errorMsg !== '') {
            var newErrorList = { ...errorTipsText, [key]: errorMsg };
            setErrorTipsText(newErrorList);
        }
    }

    const getConfigValidation = (name: string) => {
        return createConfigValidation(name, false, undefined, props.version, props.objectType);
    }

    var textAreaActivityProps: TextAreaFieldProps = {
        labelName: 'Stopień aktywności',
        textAreaPlaceholder: krForm.landslideAttributes?.stopieN_AKTYWNOSCI == null || krForm.landslideAttributes?.stopieN_AKTYWNOSCI === '' ?
            'Dodaj opis' : '',
        value: krForm.landslideAttributes?.stopieN_AKTYWNOSCI,
        textareaSharedProps: {
            className: krForm.landslideAttributes?.stopieN_AKTYWNOSCI == null
                || krForm.landslideAttributes?.stopieN_AKTYWNOSCI === '' ?
                'body-txt-medium-sec-gray' :
                'body-txt-large',
            style: {
                width: '100%',
                minHeight: '75px'
            }
        },
        configValidation: getConfigValidation("stopieN_AKTYWNOSCI"),
        validationError: isFormNotValid,
        disabled: true,
        pristine: true,
        addCommentBtn: getAddCommentBtnDetails(props.editMode!, KROFieldDict.char_stopienAktywnosci, "Stopień aktywności", props.setNewCommentFieldDetails!),
        textareaRef: (node: any) => {getFieldRef(node, KROFieldDict.char_stopienAktywnosci, props.getMapForComment!)},
        setCommentsFilter: () => { if(props.setCommentsFilter) props.setCommentsFilter(KROFieldDict.char_stopienAktywnosci); },
        isMarkedForCommentFilter: props.markedFieldForCommentFiltering === KROFieldDict.char_stopienAktywnosci,
        dynamicResize: true
    }
    var textAreaDescriptionProps: TextAreaFieldProps = {
        labelName: 'Krótki opis',
        textAreaPlaceholder: 'Dodaj opis',
        value: krForm.landslideAttributes?.charakterystykA_OPIS,
        textareaSharedProps: {
            className: 'body-txt-large',
            style: {
                width: '100%',
                minHeight: '70px'
            }
        },
        configValidation: props.collectiveEdition ? undefined : getConfigValidation("charakterystykA_OPIS"),
        disabled: !props.editMode,
        setValue: (value: any) => {
            var form = Object.assign({}, krForm);
            if (form && form.landslideAttributes) {
                form.landslideAttributes.charakterystykA_OPIS = value;
                setkrForm(form);
            }
        },
        validationError: isFormNotValid,
        pristine: true,
        tipText: errorTipsText["charakterystykA_OPIS"],
        addCommentBtn: getAddCommentBtnDetails(props.editMode!, KROFieldDict.char_krotkiOpis, "Krótki opis", props.setNewCommentFieldDetails!),
        textareaRef: (node: any) => {getFieldRef(node, KROFieldDict.char_krotkiOpis, props.getMapForComment!)},
        setCommentsFilter: () => { if(props.setCommentsFilter) props.setCommentsFilter(KROFieldDict.char_krotkiOpis); },
        isMarkedForCommentFilter: props.markedFieldForCommentFiltering === KROFieldDict.char_krotkiOpis,
        dynamicResize: true
    }

    const selectOnChange = (opt: Option[] | undefined, name: string) => {
        var form = Object.assign({}, krForm) as KrLandslideFormTypes;
        var landslideForm = form as KrLandslideFormTypes;
        if (landslideForm.landslideAttributes) {
            if (opt) {
                const option = opt.length > 0 ? opt[0] : null;
                landslideForm.landslideAttributes[name as keyof landSlideAttributes] = option?.value as number;
            } else {
                landslideForm.landslideAttributes[name as keyof landSlideAttributes] = undefined;
            }
        }
        setkrForm(form);
    }

    if (props.collectiveEdition) {
        return (
            <>
                <h2 style={{ width: '100%' }}>3. Charakterystyka</h2>
                <CollectiveSelectField top={true} value={(krForm as KrLandslideFormTypes).landslideAttributes?.sytuacjA_GEOMORFOLOGICZNA_SID} isAuto={false} title={"Sytuacja geomorfologiczna"}
                    forms={props.forms} keyName={CollectivePreviewKey.sytuacjaGeomorfologiczna} actions={props.actions} single={true} dic={geomorfologicDict}
                    setActions={props.setActions} onDelete={props.onDelete}>
                    <SelectInput label="Sytuacja geomorfologiczna"
                        onChange={(opt: Option[] | undefined) => { selectOnChange(opt, "sytuacjA_GEOMORFOLOGICZNA_SID") }}
                        hasInputTags={true} options={geomorfologicDict} onlySingleTag={true}
                        selectedOptions={prepareDataSingleForSelect(geomorfologicDict, undefined, krForm.landslideAttributes?.sytuacjA_GEOMORFOLOGICZNA_SID)} />
                </CollectiveSelectField>
                <CollectiveSelectField top={true} value={(krForm as KrLandslideFormTypes).landslideAttributes?.uklaD_GEOLOGICZNY_SID} isAuto={false} title={"Układ geologiczny"}
                    forms={props.forms} keyName={CollectivePreviewKey.ukladGeologiczny} actions={props.actions} single={true} dic={geologicDict}
                    setActions={props.setActions} onDelete={props.onDelete}>
                    <SelectInput label="Układ geologiczny"
                        onChange={(opt: Option[] | undefined) => { selectOnChange(opt, "uklaD_GEOLOGICZNY_SID") }}
                        hasInputTags={true} options={geologicDict} onlySingleTag={true}
                        selectedOptions={prepareDataSingleForSelect(geologicDict, undefined, krForm.landslideAttributes?.uklaD_GEOLOGICZNY_SID)} />
                </CollectiveSelectField>
                <CollectiveSelectField top={true} value={(krForm as KrLandslideFormTypes).landslideAttributes?.rodzaJ_MATERIALU_SID} isAuto={false} title={"Rodzaj materiału"}
                    forms={props.forms} keyName={CollectivePreviewKey.rodzajMaterialu} actions={props.actions} single={true} dic={MaterialDict}
                    setActions={props.setActions} onDelete={props.onDelete}>
                    <SelectInput label="Rodzaj materiału"
                        onChange={(opt: Option[] | undefined) => { selectOnChange(opt, "rodzaJ_MATERIALU_SID") }}
                        hasInputTags={true} options={MaterialDict} onlySingleTag={true}
                        selectedOptions={prepareDataSingleForSelect(MaterialDict, undefined, krForm.landslideAttributes?.rodzaJ_MATERIALU_SID)} />
                </CollectiveSelectField>
                <CollectiveSelectField top={true} value={(krForm as KrLandslideFormTypes).landslideAttributes?.rodzaJ_RUCHU_SID} isAuto={false} title={"Rodzaj ruchu"}
                    forms={props.forms} keyName={CollectivePreviewKey.rodzajRuchu} actions={props.actions} single={true} dic={MovingDict}
                    setActions={props.setActions} onDelete={props.onDelete}>
                    <SelectInput label="Rodzaj ruchu"
                        onChange={(opt: Option[] | undefined) => { selectOnChange(opt, "rodzaJ_RUCHU_SID") }}
                        hasInputTags={true} options={MovingDict} onlySingleTag={true}
                        selectedOptions={prepareDataSingleForSelect(MovingDict, undefined, krForm.landslideAttributes?.rodzaJ_RUCHU_SID)} />
                </CollectiveSelectField>
                <CollectiveSelectField top={true} value={(krForm as KrLandslideFormTypes).landslideAttributes?.charakterystykA_OPIS} isAuto={true} title={"Krótki opis"}
                    forms={props.forms} keyName={CollectivePreviewKey.charakterystykaOpis} actions={props.actions} single={true} preventDelete={true} preventAdd={false}
                    setActions={props.setActions} onDelete={props.onDelete}>
                    <TextAreaField {...textAreaDescriptionProps} />
                </CollectiveSelectField>
            </>
        );
    }

    return (
        <>
            <h2 ref={(node) => getItemRef(node, NavHeadingsKROEnum.Characteristics, props.getMapForNavScroll!)} style={{ width: '100%' }}>
                {props.version === PatternType.P2007 ? "3. Charakterystyka osuwiska" : "3. Charakterystyka" }
            </h2>
            <SelectInput
                configValidation={getConfigValidation("sytuacjA_GEOMORFOLOGICZNA_SID")}
                validationError={isFormNotValid}
                tipText={errorTipsText["sytuacjA_GEOMORFOLOGICZNA_SID"]}
                reload={reload}
                onChange={(opt: Option[] | undefined) => {selectOnChange(opt, "sytuacjA_GEOMORFOLOGICZNA_SID")}}
                style={styleFormFieldHalf} label="Sytuacja geomorfologiczna"
                hasInputTags={true} options={geomorfologicDict} onlySingleTag={true}
                selectedOptions={prepareDataSingleForSelect(geomorfologicDict, undefined, krForm.landslideAttributes?.sytuacjA_GEOMORFOLOGICZNA_SID)}
                pristine={true}
                disabled={!props.editMode}
                addCommentBtn={getAddCommentBtnDetails(props.editMode!, KROFieldDict.char_sytuacjaGeomorfologiczna, "Sytuacja geomorfologiczna", props.setNewCommentFieldDetails!)}
                selectRef={(node: any) => {getFieldRef(node, KROFieldDict.char_sytuacjaGeomorfologiczna, props.getMapForComment!)}} 
                setCommentsFilter={() => { if(props.setCommentsFilter) props.setCommentsFilter(KROFieldDict.char_sytuacjaGeomorfologiczna); }}
                isMarkedForCommentFilter={props.markedFieldForCommentFiltering === KROFieldDict.char_sytuacjaGeomorfologiczna}/>
            <SelectInput
                configValidation={getConfigValidation("uklaD_GEOLOGICZNY_SID")}
                validationError={isFormNotValid}
                tipText={errorTipsText["uklaD_GEOLOGICZNY_SID"]}
                reload={reload}
                onChange={(opt: Option[] | undefined) => {selectOnChange(opt, "uklaD_GEOLOGICZNY_SID")}}
                style={styleFormFieldHalf} label="Układ geologiczny"
                hasInputTags={true} options={geologicDict} onlySingleTag={true}
                selectedOptions={prepareDataSingleForSelect(geologicDict, undefined, krForm.landslideAttributes?.uklaD_GEOLOGICZNY_SID)} 
                pristine={true}
                disabled={!props.editMode}
                addCommentBtn={getAddCommentBtnDetails(props.editMode!, KROFieldDict.char_ukladGeologiczny, "Układ geologiczny", props.setNewCommentFieldDetails!)}
                selectRef={(node: any) => {getFieldRef(node, KROFieldDict.char_ukladGeologiczny, props.getMapForComment!)}} 
                setCommentsFilter={() => { if(props.setCommentsFilter) props.setCommentsFilter(KROFieldDict.char_ukladGeologiczny); }}
                isMarkedForCommentFilter={props.markedFieldForCommentFiltering === KROFieldDict.char_ukladGeologiczny}
                />
            <SelectInput
                configValidation={getConfigValidation("rodzaJ_MATERIALU_SID")}
                validationError={isFormNotValid}
                tipText={errorTipsText["rodzaJ_MATERIALU_SID"]}
                reload={reload}
                onChange={(opt: Option[] | undefined) => {selectOnChange(opt, "rodzaJ_MATERIALU_SID")}}
                style={styleFormField} label="Rodzaj materiału"
                hasInputTags={true} options={MaterialDict} onlySingleTag={true}
                selectedOptions={prepareDataSingleForSelect(MaterialDict, undefined, krForm.landslideAttributes?.rodzaJ_MATERIALU_SID)}
                pristine={true}
                disabled={!props.editMode}
                addCommentBtn={getAddCommentBtnDetails(props.editMode!, KROFieldDict.char_rodzajMaterialu, "Rodzaj materiału", props.setNewCommentFieldDetails!)}
                selectRef={(node: any) => {getFieldRef(node, KROFieldDict.char_rodzajMaterialu, props.getMapForComment!)}} 
                setCommentsFilter={() => { if(props.setCommentsFilter) props.setCommentsFilter(KROFieldDict.char_rodzajMaterialu); }}
                isMarkedForCommentFilter={props.markedFieldForCommentFiltering === KROFieldDict.char_rodzajMaterialu}
                />
            <SelectInput
                configValidation={getConfigValidation("rodzaJ_RUCHU_SID")}
                validationError={isFormNotValid}
                tipText={errorTipsText["rodzaJ_RUCHU_SID"]}
                reload={reload}
                onChange={(opt: Option[] | undefined) => {selectOnChange(opt, "rodzaJ_RUCHU_SID")}}
                style={styleFormField} label="Rodzaj ruchu"
                hasInputTags={true} options={MovingDict} onlySingleTag={true}
                selectedOptions={prepareDataSingleForSelect(MovingDict, undefined, krForm.landslideAttributes?.rodzaJ_RUCHU_SID)} 
                pristine={true}
                disabled={!props.editMode}
                addCommentBtn={getAddCommentBtnDetails(props.editMode!, KROFieldDict.char_rodzajRuchu, "Rodzaj ruchu", props.setNewCommentFieldDetails!)}
                selectRef={(node: any) => {getFieldRef(node, KROFieldDict.char_rodzajRuchu, props.getMapForComment!)}} 
                setCommentsFilter={() => { if(props.setCommentsFilter) props.setCommentsFilter(KROFieldDict.char_rodzajRuchu); }}
                isMarkedForCommentFilter={props.markedFieldForCommentFiltering === KROFieldDict.char_rodzajRuchu}
                />
            <TextAreaField {...textAreaActivityProps} />
            <TextAreaField {...textAreaDescriptionProps} />
        </>
    );
}

export default Characteristics;
